"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const typedi_1 = require("typedi");
const emitter_1 = require("./services/emitter");
const type_1 = require("./type");
const scenario_1 = require("./services/scenario");
window.EventEmitter = typedi_1.Container.get(emitter_1.EventEmitter);
window.EventType = type_1.EventType;
window.ScenarioService = typedi_1.Container.get(scenario_1.ScenarioService);
